import { SESSION_TIME_OUT } from '@/common/constants/ConstCode';
import routerInstance from '@/router/index';
import { toastAlert } from '@/common/utils/module/ToastSupport';
import { useAccountStore } from '@/store/modules/account';

/**
 * 토큰 체크
 */
const tokenCheck = (to, from, next) => {
  const accountStore = useAccountStore();
  return !(!accountStore.accessToken && to.path !== '/' && to.path !== '/login');
};

/**
 * 토큰 만료 시간 체크
 */
const sessionInvalidateCheck = (to, from, next) => {
  const accountStore = useAccountStore();

  const start = accountStore.sessionTime;
  const now = new Date().getTime();
  if (to.path === '/' || to.path === '/login') return true;
  if (!start) return false;
  if ((to.path !== '/' || to.path !== '/login') && start < now) {
    toastAlert('로그인 세션이 만료되었습니다.', 'error');
    return false;
  } else return true;
};

const notRegisteredRoutePath = (to, from, next) => {
  if (!routerInstance.hasRoute(to.name)) return false;
  else return true;
};

export { tokenCheck, sessionInvalidateCheck, notRegisteredRoutePath };